import React, { useEffect, useState } from 'react';
import LazyLoadObserver from 'components/LazyLoadObserver';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import style from './style.scss'; //NOSONAR

let actions = [];

const ImageLoad = (props) => {

    const spinner = props.spinner;
    const srcSet = props.srcSet;
    const [preloading, setPreloading] = useState(false);
    const [imgProps, setImgProps] = useState(null);
    const [image, setImage] = useState(srcSet ? null : props.src);


    useEffect(() => {
        setPreloading(true)

        _responsiveWidth();  
            
        if(srcSet && window) {
            actions.push(PubSub.register('window_on_resize', _responsiveWidth));
        }
        return function cleanup(){
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    },[])


    const handleImageLoaded = () => {
        setPreloading(false)
    }

    const _responsiveWidth = () => {
        let img = null;

        if(srcSet){
            const displayWidth = window.innerWidth;
            for(let key in srcSet){
                if(displayWidth < parseInt(key)){
                    img = srcSet[key];
                    break;
                }
            }

            if(!img){
                img = props.src;
            }
        }

        _setImage(img);
    }

    const errorImage = () => {
        if(!props.errorImage) return false;
       
        const img = props.errorImage;

        _setImage(img);
    }

    const _setImage = (img) => {
        const _image = img || image;
        
        setImgProps({
            src: _image && _image.replace ? _image.replace('http:', 'https:') : '',
            onLoad: handleImageLoaded,
            className: 'lazy-image',
            width: '100%',
            alt: props.alt ? props.alt : (img || image)
        });

        if(img && img !== image) {
            setImage(img);
        }
    }

    
    if(!image) return '';

    return (
        <LazyLoadObserver className={"lazy-image-wrap " + ((!spinner && preloading) ? ' color-gradient ' : '')+ (!preloading ? 'loaded' : '')}>
            {(preloading && spinner) && <div className="wrap-loader-image">
                <div className={"image-loader"}></div>
            </div>}
            <img {...imgProps} onError={errorImage}/>
        </LazyLoadObserver>
        
    )
    
}

ImageLoad.propTypes = {
    src: PropTypes.string,
    srcSet: PropTypes.object,
    alt: PropTypes.string,
    errorImage: PropTypes.string,
    spinner: PropTypes.bool
}

export default ImageLoad;
